import api from '../../api';
import { IDirectDiscounts } from '../../data/entities/direct-discounts';
import { ActionTypeNames, ActionValues, createActionCreators } from '../../store/actions';
import { ThunkAction } from '../../store/middleware';
import { idOrLegacyId } from '../properties/selectors';

export const getDirectDiscountActions = createActionCreators<
	{ T: 'DIRECT_DISCOUNT_GET_BY_PROP_ID_REQUEST', P: { propertyId: string } },
	{
		T: 'DIRECT_DISCOUNT_GET_BY_PROP_ID_RECEIVE', P: {
			propertyId: string,
			directDiscounts: IDirectDiscounts[]
		}
	},
	{ T: 'DIRECT_DISCOUNT_GET_BY_PROP_ID_FAILURE', P: { error: Error } }
>('DIRECT_DISCOUNT_GET_BY_PROP_ID_REQUEST', 'DIRECT_DISCOUNT_GET_BY_PROP_ID_RECEIVE', 'DIRECT_DISCOUNT_GET_BY_PROP_ID_FAILURE');

export const getDirectDiscounts = (id: string | number):
	ThunkAction<any> => async (dispatch, getState) => {
		const propertyId = idOrLegacyId(id);
		dispatch(getDirectDiscountActions.DIRECT_DISCOUNT_GET_BY_PROP_ID_REQUEST({ propertyId }));
		try {
			const directDiscounts = await api.marketingPreferences.getDirectDiscounts(propertyId);
			dispatch(getDirectDiscountActions.DIRECT_DISCOUNT_GET_BY_PROP_ID_RECEIVE({ propertyId, directDiscounts }));
		} catch (error) {
			dispatch(getDirectDiscountActions.DIRECT_DISCOUNT_GET_BY_PROP_ID_FAILURE({ error }));
			throw error;
		}
	};

const actions = {
	...getDirectDiscountActions,
};

type directDiscountsActions = ActionValues<typeof actions>;
type directDiscountsActionTypes = ActionTypeNames<directDiscountsActions>;
export type Actions = directDiscountsActions[keyof directDiscountsActions];
export const ActionTypes = Object.keys(actions).reduce((types, t) => {
	types[t] = t;
	return types;
}, {} as directDiscountsActionTypes);
